<template>
    <i :class="iconClass"></i>
</template>

<script>
export default {
    props: {
        type: String
    },
    computed: {
        iconClass() {
            return { [this.type]: true }
        },
    },
};
</script>
